import { render, staticRenderFns } from "./Staffs.vue?vue&type=template&id=74f797a3&scoped=true&"
import script from "./Staffs.vue?vue&type=script&lang=js&"
export * from "./Staffs.vue?vue&type=script&lang=js&"
import style0 from "./Staffs.vue?vue&type=style&index=0&id=74f797a3&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f797a3",
  null
  
)

export default component.exports